import { render, staticRenderFns } from "./BaseChannelPieChart.vue?vue&type=template&id=75fd89f0&"
import script from "./BaseChannelPieChart.vue?vue&type=script&lang=js&"
export * from "./BaseChannelPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports